import { useState, cloneElement } from "react";
import PropTypes from "prop-types";
// Frameworks
import { useTranslation } from "react-i18next";
import { Box, Typography, Modal, Fade, Link, Paper } from "@mui/material";
// Assets
import { Lock } from "@mui/icons-material";

const ProtectedComponent = function (props) {
  const { children, isOpen = false, isValid = false, ...remains } = props;

  const [t] = useTranslation("freemium");

  const isValidCount = localStorage.getItem("user_valid_count") > 0;
  const isUserValid = localStorage.getItem("type_user") !== "F";

  // Modal
  const [open, setOpen] = useState(isOpen);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onHandleClick = (e) => {
    if (
      (!isValid && !isUserValid) ||
      (isValid && !isValidCount && !isUserValid)
    ) {
      e.preventDefault();
      e.stopPropagation();
      window.dispatchEvent(new Event("mouseup"));
      handleOpen();
    } else if (remains.onTabClick) {
      remains.onTabClick(e, 0);
    } else if (remains.onItemClick) {
      remains.onItemClick(remains.itemValue);
      window.dispatchEvent(new Event("click"));
    } else if (children?.props?.onClick) {
      children.props.onClick(e);
    }
  };

  return (
    <>
      {cloneElement(children, {
        onClick: onHandleClick,
        onMouseDown: onHandleClick,
      })}
      {((!isValid && !isUserValid) ||
        (isValid && !isValidCount && !isUserValid)) && (
        <Box
          position="relative"
          width="100%"
          flex="0 0"
          zIndex="1"
          draggable="true"
        >
          <Box
            position="absolute"
            right={remains.iconRight}
            top={remains.iconTop}
          >
            <Lock
              style={{ fontSize: remains.iconSize, color: remains.iconColor }}
            />
          </Box>
        </Box>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        disableAutoFocus
      >
        <Fade in={open}>
          <Paper
            sx={{
              display: "flex",
              p: 3,
              alignItems: "center",
              gap: 2,
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              boxShadow: "0 10px 30px rgba(37, 62, 102, 0.15)",
            }}
          >
            <Box
              alignItems="center"
              justifyContent="center"
              display="flex"
              sx={{
                width: 72,
                height: 72,
                borderRadius: "16px",
                bgcolor: "#F7F7FA",
              }}
            >
              <Lock style={{ fontSize: 40, color: "#253E66" }} />
            </Box>
            <Box>
              <Typography
                id="transition-modal-title"
                variant="h5"
                sx={{ color: "#253E66", fontWeight: 600, fontFamily: "Catamaran" }}
              >
                {t("action")}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mb: 1 }}
              >
                {t("freemiumHint", "Esta funcionalidad no está disponible en tu plan actual.")}
              </Typography>
              <Link
                variant="body2"
                href={t("plans_link")}
                target="_blank"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  px: 1.5,
                  py: 0.6,
                  borderRadius: "10px",
                  bgcolor: "#25AAE2",
                  color: "#FFFFFF",
                  textDecoration: "none",
                  fontWeight: 600,
                  "&:hover": { bgcolor: "#1b8ec0" },
                }}
              >
                {t("improve")}
              </Link>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </>
  );
};

ProtectedComponent.propTypes = {
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool,
  isValid: PropTypes.bool,
  iconTop: PropTypes.string,
  iconRight: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconColor: PropTypes.string,
  onTabClick: PropTypes.func,
  onItemClick: PropTypes.func,
  itemValue: PropTypes.any,
};

export default ProtectedComponent;
